import type { Bounds } from '../geom';
import type { DrawingDocument } from '../model';
import type { Drawn } from '../scene';
import { toDxf } from './dxf';
import { toSvg } from './svg';

export interface ExportFormat {
  readonly id: string;
  /** What the export button says. */
  readonly label: string;
  readonly extension: string;
  readonly mimeType: string;
  /**
   * `doc` gives the layers and the unit the numbers are in; `bounds` crops a format that has
   * a page, such as SVG, to that region exactly.
   */
  write(drawn: Drawn, doc: Pick<DrawingDocument, 'layers' | 'display'>, bounds?: Bounds): string;
}

/** Every format a drawing exports to, in button order; a new one is a writer plus an entry. */
export const EXPORT_FORMATS = [
  {
    id: 'svg',
    label: 'SVG',
    extension: 'svg',
    mimeType: 'image/svg+xml',
    write: (drawn, doc, bounds?: Bounds) =>
      toSvg(drawn, { unit: doc.display.unit, ...(bounds ? { bounds } : {}) }),
  },
  {
    id: 'dxf',
    label: 'DXF',
    extension: 'dxf',
    mimeType: 'application/dxf',
    write: (drawn, doc) => toDxf(drawn, doc.layers, doc.display.unit),
  },
] as const satisfies readonly ExportFormat[];
